import { render, staticRenderFns } from "./WorkbookItem.vue?vue&type=template&id=50f0b14e"
import script from "./WorkbookItem.vue?vue&type=script&lang=js"
export * from "./WorkbookItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports